export enum CheckpointType {
  WAREHOUSE = 'warehouse',
  HARBOUR = 'harbour',
  TRUCK = 'truck',
  FACTORY = 'factory',
  NONE = 'none'
}
